
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5278',
  depVersions: {
  "data-privacy-request-ui": "static-1.5278",
  "data-fetching-client": "static-1.9430",
  "head-dlb": "static-1.4754",
  "history": "static-4.47",
  "hs-test-utils": "static-1.7756",
  "hub-http-shared-msw-handlers": "static-1.9366",
  "hubspot-dlb": "static-2.1786",
  "HubStyleTokens": "static-2.11175",
  "I18n": "static-7.1558",
  "jasmine-runner": "static-1.6224",
  "privacy-center-public-service-types": "static-1.4541",
  "quartz": "static-1.6664",
  "react-dlb": "static-1.71",
  "react-router-dom": "static-5.26",
  "ui-components-test-utils": "static-1.5313",
  "UIComponents": "static-3.8122",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.80",
  "foundations-assets": "static-1.4585",
  "foundations-components": "static-1.7428",
  "foundations-components-test-utils": "static-1.4911",
  "foundations-theming": "static-1.4162",
  "hub-http": "static-1.5872",
  "quartz-config": "static-1.442",
  "quartz-core": "static-1.5883",
  "quick-fetch": "static-1.3691",
  "raven": "static-3.5624",
  "react": "static-7.177",
  "react-rhumb": "static-1.16392",
  "SharedI18nStrings": "static-1.180",
  "ui-addon-i18n": "static-1.10885",
  "usage-tracker": "static-1.7087",
  "usage-tracker-anonymous": "static-1.5504",
  "usage-tracker-core": "static-1.6937",
  "enviro": "static-4.387",
  "hs-promise-rejection-tracking": "static-1.5291",
  "PortalIdParser": "static-2.349",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.3873",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9346",
  "react-redux": "static-7.66",
  "redux": "static-4.16",
  "styled-components": "static-2.84",
  "bend-plugin-trellis-migration": "static-1.3187",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.2941",
  "quartz-webpack": "static-1.2888",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.76",
  "HeadJS": "static-2.701",
  "framer-motion": "static-1.66",
  "hs-test-utils-bend-plugin": "static-1.2867",
  "msw": "static-1.39",
  "testing-library": "static-1.146",
  "ts-schema": "static-1.3865",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.77",
  "react-utils": "static-2.5134",
  "StyleGuideUI": "static-3.483",
  "jasmine": "static-4.4084",
  "rpc-client-utils": "static-1.4384",
  "HubStyle": "static-2.11483",
  "ui-addon-draggable": "static-3.4516",
  "cssUtils": "static-1.719",
  "hs-story-utils": "static-1.9181",
  "icons": "static-2.618",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.93",
  "ui-images": "static-2.1079",
  "bend-plugin-foundations-components": "static-1.3697",
  "floating-ui": "static-1.50",
  "foundations-theming-specialty": "static-1.1878",
  "react-aria": "static-1.60",
  "tanstack-table": "static-1.49",
  "trellis-assets": "static-1.1068",
  "ui-fonts": "static-1.437",
  "bend-plugin-foundations-theming": "static-1.2645",
  "foundations-theming-base": "static-1.3147",
  "stylex": "static-1.26",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.784",
  "hubspotter-http": "static-1.4439",
  "mobile-manifest-mixins": "static-1.474",
  "quartz-auth": "static-1.339",
  "quartz-head": "static-1.329",
  "quartz-i18n": "static-1.339",
  "quartz-routing": "static-1.94",
  "quartz-test": "static-1.339",
  "usage-tracker-container": "static-1.7077",
  "csstype": "static-1.50",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.2886",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.64",
  "sassPrefix": "static-1.151",
  "hubspotter-http-shared-msw-handlers": "static-1.9364"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5278",
  "data-fetching-client": "/data-fetching-client/static-1.9430",
  "head-dlb": "/head-dlb/static-1.4754",
  "history": "/history/static-4.47",
  "hs-test-utils": "/hs-test-utils/static-1.7756",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9366",
  "hubspot-dlb": "/hubspot-dlb/static-2.1786",
  "HubStyleTokens": "/HubStyleTokens/static-2.11175",
  "I18n": "/I18n/static-7.1558",
  "jasmine-runner": "/jasmine-runner/static-1.6224",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4541",
  "quartz": "/quartz/static-1.6664",
  "react-dlb": "/react-dlb/static-1.71",
  "react-router-dom": "/react-router-dom/static-5.26",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5313",
  "UIComponents": "/UIComponents/static-3.8122",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.80",
  "foundations-assets": "/foundations-assets/static-1.4585",
  "foundations-components": "/foundations-components/static-1.7428",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4911",
  "foundations-theming": "/foundations-theming/static-1.4162",
  "hub-http": "/hub-http/static-1.5872",
  "quartz-config": "/quartz-config/static-1.442",
  "quartz-core": "/quartz-core/static-1.5883",
  "quick-fetch": "/quick-fetch/static-1.3691",
  "raven": "/raven/static-3.5624",
  "react": "/react/static-7.177",
  "react-rhumb": "/react-rhumb/static-1.16392",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10885",
  "usage-tracker": "/usage-tracker/static-1.7087",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5504",
  "usage-tracker-core": "/usage-tracker-core/static-1.6937",
  "enviro": "/enviro/static-4.387",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3873",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9346",
  "react-redux": "/react-redux/static-7.66",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.84",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3187",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2941",
  "quartz-webpack": "/quartz-webpack/static-1.2888",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.76",
  "HeadJS": "/HeadJS/static-2.701",
  "framer-motion": "/framer-motion/static-1.66",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2867",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.146",
  "ts-schema": "/ts-schema/static-1.3865",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.77",
  "react-utils": "/react-utils/static-2.5134",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "jasmine": "/jasmine/static-4.4084",
  "rpc-client-utils": "/rpc-client-utils/static-1.4384",
  "HubStyle": "/HubStyle/static-2.11483",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4516",
  "cssUtils": "/cssUtils/static-1.719",
  "hs-story-utils": "/hs-story-utils/static-1.9181",
  "icons": "/icons/static-2.618",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.93",
  "ui-images": "/ui-images/static-2.1079",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3697",
  "floating-ui": "/floating-ui/static-1.50",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1878",
  "react-aria": "/react-aria/static-1.60",
  "tanstack-table": "/tanstack-table/static-1.49",
  "trellis-assets": "/trellis-assets/static-1.1068",
  "ui-fonts": "/ui-fonts/static-1.437",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2645",
  "foundations-theming-base": "/foundations-theming-base/static-1.3147",
  "stylex": "/stylex/static-1.26",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.784",
  "hubspotter-http": "/hubspotter-http/static-1.4439",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.474",
  "quartz-auth": "/quartz-auth/static-1.339",
  "quartz-head": "/quartz-head/static-1.329",
  "quartz-i18n": "/quartz-i18n/static-1.339",
  "quartz-routing": "/quartz-routing/static-1.94",
  "quartz-test": "/quartz-test/static-1.339",
  "usage-tracker-container": "/usage-tracker-container/static-1.7077",
  "csstype": "/csstype/static-1.50",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.2886",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.64",
  "sassPrefix": "/sassPrefix/static-1.151",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9364"
}
};
